import type { PsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';

type Variants = NonNullable<PsfPromoteOrSharePageData['psfComboCopyExperiment']['config']['copy']>['variants'];

type Result = ModelHookResult<{
	// psf_combo_copy_experiment FCM payload for the user's variation: absence means "use the default copy"
	variant: Variants[keyof Variants] | undefined;
}>;

export function useComboCopyVariant(): Result {
	const {
		data: { psfComboCopyExperiment },
	} = usePsfPromoteOrSharePageData();

	const { variation, config, fallback } = psfComboCopyExperiment;
	// fallback resolutions (donation language, exclusion group, errors, bots) keep the default copy
	const variants = fallback ? undefined : config.copy?.variants;

	return {
		data: {
			// fake_control must render byte-identical to control (A/A check), so its own payload is ignored
			variant: variation === 'fake_control' ? variants?.control : variants?.[variation],
		},
	};
}
